function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { jsx as _jsx } from "react/jsx-runtime";
import BugsnagPerformance from "@bugsnag/browser-performance";
import Bugsnag from "@bugsnag/js";
import { Component } from "react";
import { Emitter } from "../../services";
import { Revision } from "../../utils";
import { getLogger, hasBugsnagLogging } from "../../utils/logger";
import { ErrorPage } from "./ErrorPage";
var log = getLogger("application");
var logError = function(error) {
    log.error("Unhandled error", error, {
        info: "emitter"
    });
};
var ErrorCatcher = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(ErrorCatcher, Component);
    var _super = _create_super(ErrorCatcher);
    function ErrorCatcher(props) {
        _class_call_check(this, ErrorCatcher);
        var _this;
        _this = _super.call(this, props);
        var apiKey = props.apiKey;
        var isTracking = !!apiKey && hasBugsnagLogging();
        _this.state = {
            hasError: false,
            isTracking: isTracking
        };
        if (isTracking) {
            var _Revision_getRevision = Revision.getRevision(), appName = _Revision_getRevision.appName, appVersion = _Revision_getRevision.appRevision;
            Bugsnag.start({
                apiKey: apiKey,
                appVersion: appVersion,
                metadata: {
                    appName: appName
                }
            });
            BugsnagPerformance.start({
                apiKey: apiKey,
                appVersion: appVersion
            });
        }
        return _this;
    }
    _create_class(ErrorCatcher, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                Emitter.on("error", logError);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                Emitter.off("error", logError);
            }
        },
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                log.error("Unhandled error", error, _object_spread({}, errorInfo));
            }
        },
        {
            key: "render",
            value: function render() {
                if (this.state.hasError) {
                    return /*#__PURE__*/ _jsx(ErrorPage, {
                        error: this.state.error
                    });
                }
                return this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error,
                    hasError: true
                };
            }
        }
    ]);
    return ErrorCatcher;
}(Component);
export default ErrorCatcher;

//# sourceMappingURL=ErrorCatcher.js.map